export const MODULES = {
  ACCOUNTING: 'accounting',
  TREASURY: 'tesorería',
  BUDGET: 'budget',
  VAULT: 'vault',
  MAESTROS: 'maestros',
  INVOICING: 'invoicing',
} as const;

/**
 * Productos de la fase 2 que se muestran en construccion: tienen menu, pero cada opcion abre la
 * pantalla «En construccion» con su fecha de entrega planeada (pedido de gerencia, 29-oct-2026).
 */
export const MODULOS_EN_CONSTRUCCION = ['mass-billing', 'supplies', 'payroll', 'portal'] as const;

/** Dato de ruta con el modulo en construccion que contiene la pantalla. */
export const DATA_MODULO_EN_CONSTRUCCION = 'moduloEnConstruccion';

export type ModuloEnConstruccion = (typeof MODULOS_EN_CONSTRUCCION)[number];

/**
 * Si el modulo es uno de los productos en construccion.
 *
 * @param modulo segmento del modulo (`/layout/<modulo>/...`)
 * @returns si su menu abre la pantalla «En construccion»
 */
export function esModuloEnConstruccion(modulo: string): modulo is ModuloEnConstruccion {
  return (MODULOS_EN_CONSTRUCCION as readonly string[]).includes(modulo);
}

export type ModuleValue = (typeof MODULES)[keyof typeof MODULES];
